module.exports = __webpack_public_path__ + "img/08—01—04—Diagnostic information > WLAN Steering.d8168042.jpg";